import { isoZ, z } from 'my-zod'

export const revisionModel = z.object({
  userId: z.number(),
  lastModifiedDate: isoZ.instant().nullable(),
  diff: z.record(
    z.object({
      old: z.any(),
      new: z.any()
    })
  ),
  full: z.any()
})

export type revisionModel = z.infer<typeof revisionModel>
